export default "__VITE_ASSET__BfhiTYas__"